/**
 * yy-reveal.js
 * Intersection Observer that transitions .yy-reveal--pending
 * to .yy-reveal--visible once the element enters the viewport.
 * Falls back to immediate reveal if IntersectionObserver is unsupported.
 *
 * THRESHOLD IS 0, NOT 0.1 - deliberately.
 * A threshold of 0.1 asks for 10% of the element to be visible. On mobile the
 * grids collapse to one or two columns and get very tall, and once an element
 * is taller than about ten viewports that ratio becomes mathematically
 * unreachable - the callback never fires and the content stays invisible for
 * good. The -60px bottom rootMargin already provides the "must be properly
 * into view" delay, so the threshold is not doing any work worth that risk.
 */
(function () {
  'use strict';

  var PENDING  = 'yy-reveal--pending';
  var VISIBLE  = 'yy-reveal--visible';
  var ROOT_MARGIN = '0px 0px -60px 0px';
  var THRESHOLD   = 0;

  function revealAll(nodes) {
    Array.prototype.forEach.call(nodes, function (el) {
      el.classList.remove(PENDING);
      el.classList.add(VISIBLE);
    });
  }

  if (!('IntersectionObserver' in window)) {
    // Immediate fallback for old browsers
    revealAll(document.querySelectorAll('.' + PENDING));
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.remove(PENDING);
          entry.target.classList.add(VISIBLE);
          observer.unobserve(entry.target);
        }
      });
    },
    { rootMargin: ROOT_MARGIN, threshold: THRESHOLD }
  );

  function observeAll() {
    document.querySelectorAll('.' + PENDING).forEach(function (el) {
      observer.observe(el);
    });
  }

  // Observe on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeAll);
  } else {
    observeAll();
  }

  // Re-observe after Shopify section updates in theme editor
  document.addEventListener('shopify:section:load', function () {
    observeAll();
  });

  /**
   * Safety net. The pending state hides elements in CSS and depends on this
   * script to un-hide them, so anything that stops the observer firing hides
   * content permanently. After 3 seconds, reveal whatever is still pending.
   * On a normal page load every visible element has already been unobserved
   * by then, so this only ever catches genuine failures.
   */
  window.setTimeout(function () {
    var stuck = document.querySelectorAll('.' + PENDING);
    if (!stuck.length) return;
    Array.prototype.forEach.call(stuck, function (el) {
      var box = el.getBoundingClientRect();
      // Only force elements already at or above the fold - anything further
      // down should still animate normally when it is scrolled to.
      if (box.top < window.innerHeight) {
        el.classList.remove(PENDING);
        el.classList.add(VISIBLE);
        observer.unobserve(el);
      }
    });
  }, 3000);
})();
